/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AlbumManagementEditAlbumRequest = {
  id?: number | null;
  groupId?: number;
  title: string;
  openSatatus: AlbumManagementEditAlbumRequest.openSatatus;
  postDate?: string;
  releaseSetting?: string | null;
  postGroups: Array<string>;
  attachFiles: Array<string>;
};

export namespace AlbumManagementEditAlbumRequest {
  export enum openSatatus {
    RELEASE = "release",
    DELETE = "delete",
    EDITING = "editing",
  }
}
